import { render, staticRenderFns } from "./LicensePane.vue?vue&type=template&id=29e85a16&scoped=true"
import script from "./LicensePane.vue?vue&type=script&lang=js"
export * from "./LicensePane.vue?vue&type=script&lang=js"
import style0 from "./LicensePane.vue?vue&type=style&index=0&id=29e85a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e85a16",
  null
  
)

export default component.exports